import { gql } from '../../../apollo/__generated__';

export const CREATE_TINDER = gql(`
  mutation CreateTinder($createTinderInput: CreateTinderInput!, $eventId: ID!) {
    createTinder(createTinderInput: $createTinderInput) {
      id
      remainingSuperLikes(eventId: $eventId)
    }
  }
`);
